<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title *ngIf="!isDetail" #resultTitle>検索結果</mat-card-title>
        <mat-card-title *ngIf="isDetail" #detailTitle>未精算情報</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="table-responsive" style="max-height: 500px;">
            <table mat-table [dataSource]="dataSource" matSort [style.min-width]="minWidth"
                *ngFor="let displayedColumns of displayedColumnsCol">
                <ng-container matColumnDef="kinkoOccurrenceDate">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:95px;">未精算発生日</th>
                    <td mat-cell *matCellDef="let row">{{
                        this.timeApiService.convertStringToDate(row.kinkoOccurrenceDate) | date : 'YYYY/MM/dd'}}</td>
                </ng-container>
                <ng-container matColumnDef="paymentContractNo">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:120px">支払契約番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.paymentContractNo }}</td>
                </ng-container>
                <ng-container matColumnDef="visitName">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width: 85px;">請求先名</th>
                    <td mat-cell *matCellDef="let row">{{ row.visitName }}</td>
                </ng-container>
                <ng-container matColumnDef="receiveMoneyNo">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:120px">入金番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.receiveMoneyNo }}</td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyDate">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:95px;">入金日</th>
                    <td mat-cell *matCellDef="let row">{{ this.timeApiService.convertStringToDate(row.rcvmnyDate) | date
                        : 'YYYY/MM/dd'}}</td>
                </ng-container>
                <ng-container matColumnDef="inmny">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:105px">入金額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.inmny|number}}</td>
                </ng-container>
                <ng-container matColumnDef="remny">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:105px">未精算額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.remny|number}}</td>
                </ng-container>
                <ng-container matColumnDef="jikaiClaimPlndate">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:102px">次回請求予定日</th>
                    <td mat-cell *matCellDef="let row">{{ this.timeApiService.convertStringToDate(row.jikaiClaimPlndate)
                        | date : 'YYYY/MM/dd'}}</td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyKeitai">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:85px">入金形態</th>
                    <td mat-cell *matCellDef="let row">{{ row.rcvmnyKeitai }}</td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyFclt">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:150px">入金機関</th>
                    <td mat-cell *matCellDef="let row">{{ row.rcvmnyFclt }}</td>
                </ng-container>
                <ng-container matColumnDef="kinkoSts">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:115px">未精算ステータス</th>
                    <td mat-cell *matCellDef="let row">{{row.kinkoSts}} </td>
                </ng-container>
                <ng-container matColumnDef="kinkoReason">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:115px">未精算理由</th>
                    <td mat-cell *matCellDef="let row">{{ row.kinkoReason }}</td>
                </ng-container>
                <ng-container matColumnDef="kakuhoNotarrive">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:66px">確報未着</th>
                    <td mat-cell *matCellDef="let row">{{ row.kakuhoNotarrive }}</td>
                </ng-container>
                <ng-container matColumnDef="kouzaReg">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:66px">口座登録</th>
                    <td mat-cell *matCellDef="let row" class="text-center">{{ row.kouzaReg }}</td>
                </ng-container>
                <ng-container matColumnDef="effectCtrUmu">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:90px">有効契約有無</th>
                    <td mat-cell *matCellDef="let row" class="text-center">{{ row.effectCtrUmu}}</td>
                </ng-container>
                <ng-container matColumnDef="rpaytoConfirmationrequestDate">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:95px;">返金先確認日</th>
                    <td mat-cell *matCellDef="let row">{{
                        this.timeApiService.convertStringToDate(row.rpaytoConfirmationrequestDate) | date :
                        'YYYY/MM/dd'}}</td>
                </ng-container>
                <ng-container matColumnDef="kinkoTrnDate">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width:95px;">未精算処理日</th>
                    <td mat-cell *matCellDef="let row">{{ this.timeApiService.convertStringToDate(row.kinkoTrnDate) |
                        date : 'YYYY/MM/dd'}}</td>
                </ng-container>
                <ng-container matColumnDef="kinkoTrnTntsh">
                    <th mat-sort-header [disabled]="isDetail" mat-header-cell class="border-bottom-double"
                        *matHeaderCellDef style="min-width: 85px;">処理担当者</th>
                    <td mat-cell *matCellDef="let row">{{ row.kinkoTrnTntsh }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns" [class]="isDetail?'':'clickable-mat-row'"
                    (dblclick)="onClickRow(row, $event)">
                </tr>
            </table>
        </div>
    </mat-card-content>
</mat-card>